"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const jquery_1 = __importDefault(require("jquery"));
const two_js_1 = __importDefault(require("two.js"));
const axios_1 = __importDefault(require("axios"));
const bs_stepper_1 = __importDefault(require("bs-stepper"));
const vue_slideout_panel_vue_1 = __importDefault(require("../vue-slideout-panel.vue"));
const EventBus_1 = __importDefault(require("../../EventBus"));
const WindowHelper_1 = __importDefault(require("../../WindowHelper"));
const BallScrew_1 = require("./models/BallScrew");
let Drawer = class Drawer extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        // List of diameters from api
        this.diameters = Array();
        // List of all diameters in database
        this.allDiameters = Array();
        // List of leads from api
        this.leads = Array();
        // List of all leads in database
        this.allLeads = Array();
        // List of ballScrews from api
        this.items = Array();
        // List of stars from api
        this.stars = Array(1, 2);
        // Stepper component instance
        this.stepper = null;
        // Stepper state
        this.wizardComplete = false;
        // Save if user did click "change bullnut"
        this.back = false;
        // Selected type from stepper
        this.selected_type = "";
        // Selected diameter from stepper
        this.selected_diameter = 0;
        // Selected lead from stepper
        this.selected_lead = 0;
        // Selected number of stars
        this.selected_star = 0;
        // Saving current state
        this.isSaving = false;
        // List of global events to listen for resizing window and canvas
        this.eventsToListen = ['SIDE_BAR_EXPANDED', 'SIDE_BAR_MINIMIZED', 'WINDOW_DID_RESIZE'];
        // Class for ballscrew creator
        this.ballScrewObj = new BallScrew_1.BallScrew();
        // List of fields for ball screws table
        this.fields = [
            { key: "code", label: 'Ball Nut' },
            { key: "nominal_diameter", label: 'Nominal Diameter d0 [mm]' },
            { key: "lead", label: 'Lead [mm]' },
            { key: "nr_stars", label: 'No. Starts' },
            { key: "balls_diameter", label: 'Balls Diameter [mm]' },
            { key: "nr_circuits", label: 'No. Circuits' },
            { key: "dynamic_load", label: 'Dynamic Load Ca [kN]' },
            { key: "static_load", label: 'Static Load Co [kN]' },
            { key: "D1", label: 'Nut Body Diameter [mm]' },
            { key: "L14", label: 'Nut Length [mm]' },
            'Actions'
        ];
        // List of fields for details ballscrews table
        this.fields1 = [
            { key: "root_diameter", label: 'dr [mm]' },
            { key: "stiffness", label: 'Rb/t [N/μm]' },
            { key: "D1", label: 'D1 [mm]' },
            { key: "F2", label: 'F2' },
            { key: "D4", label: 'D4 [mm]' },
            { key: "D5", label: 'D5 [mm]' },
            { key: "D6", label: 'D6 [mm]' },
            { key: "L1", label: 'L1 [mm]' },
            { key: "L3", label: 'L3 [mm]' },
            { key: "L7", label: 'L7 [mm]' },
            { key: "L8", label: 'L8 [mm]' },
            { key: "L9", label: 'L9 [mm]' },
            { key: "L14", label: 'L14 [mm]' },
        ];
        // Documentation options
        this.options_documentation = [
            { text: 'No', value: false },
            { text: 'Yes', value: true },
        ];
        // Busy indicator for ball screws table
        this.isBusy = true;
        // Show or hide navigation bar
        this.showNavigation = false;
        // List of protections method
        this.protections = [];
        // List of lubrications types
        this.lubrications = [];
        // List of documentations
        this.documentations = [];
        // List of precisions types
        this.precisions = [];
        // Loading state while download ball screw data to draw, it display central spinner
        this.loading = false;
        // Indicator for button
        this.submitting = false;
        // True when a ball screw did draw on canvas
        this.drawed = false;
        // Side panel state, if true, side panel did appear
        this.sidepanel = false;
        // Selected record of ball screw draw on canvas
        this.selected = null;
        // Current scale factor
        this.scaleFactor = 1.5;
        // Maximum scale factor
        this.maxScaleFactor = 13;
        // List of flange for side panel configuration
        this.flange = [];
        // Describe the panel to be opened (terminalLeft|terminalRight|settings)
        this.panel = '';
        // HTMLObject of current canvas
        this.elem = null;
        // Hide or show quotes on canvas
        this.showQuotes = true;
        // Array of BallScrewElement registered to hide or show quotes
        this.elementsToQuotes = [];
        // Data for current configuration
        this.configuration = {};
        // Socket image
        this.socketImage = 'f0';
        // Base configuration
        this.base_configuration = {
            protection: '',
            precision: '',
            flange: '',
            lubrication: 'Standard grease',
            documentations: [],
            terminal: '',
            screwLength: 0,
            name: '',
            nameState: null,
            left_terminal_record: null,
            right_terminal_record: null,
            need_documentation: false,
            left_socket: '',
            right_socket: '',
            socket: '',
            // Controls buttons
            controls: {
                settings: null,
                left_terminal: null,
                right_terminal: null,
                edit_left_terminal: null,
                edit_right_terminal: null,
            }
        };
        // Callback for virtual tour
        this.myTourCallback = {
            onStop: () => {
                this.$store.commit('tourDidEnd');
            }
        };
    }
    // COMPUTED VARIABLES
    get nonStandardDesc() {
        return this.configuration.precision.id == 4 || this.configuration.precision.id == 5 ?
            "Non-Standard Product" : '';
    }
    // Steps for virtual tour
    get steps() {
        const editIdLeft = (this.configuration.left_terminal_record === null) ? '#leftConf' : '#leftConfEdit';
        const editIdRight = (this.configuration.right_terminal_record === null) ? '#rightConf' : '#rightConfEdit';
        let step = [
            {
                target: '#drawCode',
                content: '<i class="fas fa-flag fa-3x"></i><br /><b>Welcome to UMBRAGROUP Ball Screw Configurator!</b><br >This is a this short introduction to the main configuration features.'
            },
            {
                target: '#mainConf',
                content: ' From this button you will have access to the <b>screw and nut configuration</b>, it will always be accessible here!'
            },
            {
                target: editIdLeft,
                content: 'From this button it’s possible to configure the <b>left shaft end</b>. Once configured, this button will change icon and color, but will always remain available for subsequent changes.'
            },
            {
                target: editIdRight,
                content: 'From this button it’s possible to configure the <b>right shaft end</b>. Once configured, this button will change icon and color, but will always remain available for subsequent changes.'
            },
            {
                target: '#quotes',
                content: 'From this button you can display or hide the <b>drawing dimensions</b>!',
                params: {
                    placement: 'right'
                }
            },
            {
                target: '#changeballnut',
                content: 'From this button, you can change the type of Ball Nut, or just review the selected one. <b>Attention:</b> changing the Ball Nut type, any configurations made will be lost.'
            },
            {
                target: '#buttonSave',
                content: 'Once the configuration is complete, you can save and proceed using this button, which will be inactive until you have fully configured the product.'
            },
            {
                target: '#buttonHelp',
                content: '<i class="fas fa-medal fa-3x"></i><br />The tutorial is finished,<br />  you can access this tour at any time using this button!<br><b>THANKS FOR CHOOSING<br />UMBRAGROUP!</b>'
            }
        ];
        return step;
    }
    get centerGap() {
        return this.selected.D6 * this.ballScrewObj.getScaleFactor() / 2 - 80;
    }
    // Flange type, based on diameters
    get flange_types() {
        return this.selected != null ? (this.selected.nominal_diameter >= 40 ? ['a4', 'b4', 'c4'] : ['a3', 'b3', 'c3']) : [];
    }
    // Length state
    get lengthState() {
        return this.configuration.screwLength >= this.minWidth && this.configuration.screwLength <= this.maxWidth;
    }
    // Calculate minimun width
    get minWidth() {
        return Math.round(Math.max(this.selected.lead * 3, this.selected.nominal_diameter * 4) + this.selected.L14);
    }
    // Get the max length value
    get maxWidth() {
        return this.selected.max_thread_length.max;
    }
    // WATCHER
    onShowQuotesChanges(val, oldVal) {
        if (val) {
            this.ballScrewObj.showAllQuotes();
        }
        else {
            this.ballScrewObj.hideAllQuotes();
        }
    }
    onSelectedTypeChanged(val, oldVal) {
        if (this.wizardComplete) {
            //this.selected_lead = 0;
            //this.selected_diameter = 0;
            this.getBallScrew();
        }
    }
    onSelectedDiameterChanged(val, oldVal) {
        if (this.wizardComplete) {
            this.setDiameter(val);
            if (val == 0) {
                this.leads = this.allLeads;
            }
            this.getBallScrew();
        }
    }
    onSelectedLeadChanged(val, oldVal) {
        if (this.wizardComplete) {
            this.setBLead(val);
            this.getBallScrew();
        }
    }
    onSelectedStarChanged(val, oldVal) {
        if (this.wizardComplete) {
            this.getBallScrew();
        }
    }
    // Created method
    created() {
        window.onbeforeunload = () => {
            if (this.idConfiguration > 0) {
                return;
            }
            if (this.selected !== null && this.isSaving == false) {
                return "La tua configurazione non è stata salvata, sei sicuro di abbandonare la pagina?";
            }
            return;
        };
    }
    // Mounted method
    mounted() {
        // Initialize base configuration cloning base
        this.configuration = Object.assign({}, this.base_configuration);
        // Listen for global app event
        this.registerForEvents();
        // Initialize stepper
        this.stepper = new bs_stepper_1.default(document.querySelector('.bs-stepper'), {
            linear: false,
            animation: true
        });
        setTimeout(() => {
            jquery_1.default('#canvas').fadeTo(1000, 1);
        }, 1000);
        if (this.idConfiguration > 0) {
            this.loading = true;
            axios_1.default.get('/api/drawer/get_configuration/' + this.idConfiguration).then(res => {
                this.drawConfiguration(res.data);
            }).catch(err => {
                console.log(err);
                this.notify("Error", "Si è verificato un errore durante l'apertura della configurazione", "error");
                this.isBusy = false;
                this.loading = false;
            });
        }
        else {
            setTimeout(() => {
                this.isBusy = false;
            }, 500);
        }
    }
    /**
     * Register for global event
     */
    registerForEvents() {
        this.eventsToListen.forEach((event) => {
            EventBus_1.default.$on(event, () => {
                this.handleResize();
            });
        });
    }
    /**
     * Handle resize method
     */
    handleResize() {
        setTimeout(() => {
            WindowHelper_1.default();
            setTimeout(() => {
                if (this.selected != null) {
                    this.renderBallScrew();
                }
            }, 100);
        }, 300);
    }
    /**
     * Check if current row is the selected terminal row
     */
    styleTerminalRow(item, type) {
        if (!item)
            return;
        if (this.panel === "terminalLeft" && this.configuration.left_terminal_record != null) {
            if (item.idterminal === this.configuration.left_terminal_record.idterminal)
                return 'table-success';
        }
        else if (this.panel === "terminalRight" && this.configuration.right_terminal_record != null) {
            if (item.idterminal === this.configuration.right_terminal_record.idterminal)
                return 'table-success';
        }
    }
    /**
     * Check if current row is the selected ballscrew row
     */
    styleBallScrewRow(item, type) {
        if (!item || this.selected == null)
            return;
        if (item.code === this.selected.code)
            return 'table-success';
    }
    /**
     * notify user
     */
    notify(title, message, type = "success") {
        this.$notify({
            type: type,
            group: 'foo',
            title: title,
            text: message
        });
    }
    /**
     * Close sidepanel and save
     */
    closeAndSave() {
        this.sidepanel = false;
        this.renderBallScrew();
    }
    /**
     * Check if we can draw code
     */
    canDraw(code) {
        // If user did show back, return to saved configuration
        if (this.back && this.selected.code == code) {
            this.back = false;
            return;
        }
        else if (this.two != null) {
            this.$swal({
                title: 'Are you sure?',
                text: "By changing the Ball Nut type, all previous settings will be lost!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, proceed!'
            }).then((result) => {
                if (result.value) {
                    this.configuration = Object.assign({}, this.base_configuration);
                    this.two.clear();
                    this.two.update();
                    this.clearControls();
                    this.selected = null;
                    this.ballScrewObj = new BallScrew_1.BallScrew();
                    this.draw(code);
                }
            });
        }
        else {
            this.draw(code);
        }
    }
    /**
     * Draw a complete ball Screw based on his code
     * @param code
     */
    draw(code) {
        this.back = false;
        this.loading = true;
        setTimeout(() => {
            jquery_1.default('#canvas').fadeTo(1000, 1);
            // Get canvas element
            this.elem = document.getElementById('canvas');
            // Resize canvas to fill entire space
            WindowHelper_1.default();
            // Instance two.js library
            if (this.two == null) {
                this.two = new two_js_1.default({
                    width: '100%',
                    height: '100%'
                }).appendTo(this.elem);
            }
            axios_1.default.post('/internalapi/get/' + code).then((res) => {
                // Save selected ball screw
                this.selected = res.data;
                this.loadConfigurationParams().then((res) => {
                    this.renderBallScrew();
                });
            });
        }, 1000);
    }
    /**
     * Draw a complete ball Screw based on saved configuration
     * @param configuration
     */
    drawConfiguration(configuration) {
        setTimeout(() => {
            // Get canvas element
            this.elem = document.getElementById('canvas');
            // Resize canvas to fill entire space
            WindowHelper_1.default();
            // Instance two.js library
            this.two = new two_js_1.default({
                width: '100%',
                height: '100%'
            }).appendTo(this.elem);
            this.selected = configuration.ballScrew;
            this.configuration.flange = configuration.configuration.flange;
            this.configuration.precision = configuration.configuration.precision;
            // Load precision, protections, ecc.
            this.loadConfigurationParams().then((res) => {
                // Initialize select value based on saved values
                this.configuration.protection = this.protections.find((el) => {
                    return el.id === configuration.configuration.protection.id;
                }) || this.protections[0];
                this.configuration.precision = this.precisions.find((el) => {
                    return el.id === configuration.configuration.precision.id;
                }) || this.precisions[0];
                this.configuration.lubrication = this.lubrications.find((el) => {
                    return el.id === configuration.configuration.lubrication.id;
                }) || this.lubrications[0];
            });
            const thereIsDocumentation = configuration.configuration.documentations != null && configuration.configuration.documentations.length;
            this.configuration.flange = configuration.configuration.flange;
            this.configuration.documentations = thereIsDocumentation > 0 ? configuration.configuration.documentations.split(",") : [];
            this.configuration.screwLength = configuration.configuration.screwLength;
            this.configuration.name = configuration.configuration.name;
            this.configuration.need_documentation = thereIsDocumentation;
            this.configuration.left_socket = configuration.configuration.socket_left;
            this.configuration.right_socket = configuration.configuration.socket_right;
            this.populateAllSelects(configuration.configuration.ballscrew);
            if (configuration.left_terminal != null) {
                this.configuration.left_terminal_record = configuration.left_terminal;
            }
            if (configuration.right_terminal != null) {
                this.configuration.right_terminal_record = configuration.right_terminal;
            }
            this.renderBallScrew();
            //$('#topbar').animate({ scrollTop: ($('#canvas').height() - $('#topbar').height()) / 2 + 60 }, 0);
            jquery_1.default('#canvas').fadeTo(1000, 1);
        }, 1000);
    }
    /**
     * Load all configuration params
     */
    loadConfigurationParams() {
        return __awaiter(this, void 0, void 0, function* () {
            // Request fields for all select
            const response = yield axios_1.default.all([
                axios_1.default.get('/api/drawer/get_documentations/' + this.selected.preload.toUpperCase()),
                axios_1.default.get('/api/drawer/get_lubrications'),
                axios_1.default.get('/api/drawer/get_precisions/' + this.selected.preload.toUpperCase()),
                axios_1.default.get('/api/drawer/get_protections'),
            ])
                .then(axios_1.default.spread((documentations, lubrications, precisions, protections) => {
                this.documentations = documentations.data;
                this.lubrications = lubrications.data;
                this.precisions = precisions.data;
                this.protections = protections.data;
            }));
            // Initialize values
            this.configuration.protection = this.protections[0];
            this.configuration.precision = this.precisions[0];
            this.configuration.lubrication = this.lubrications[0];
            return response;
        });
    }
    /**
     * Check if passed terminal, is the current selected
     */
    isCurrentTerminal(value) {
        if (this.panel === "terminalLeft" && this.configuration.left_terminal_record != null) {
            return value === this.configuration.left_terminal_record.idterminal;
        }
        else if (this.panel === "terminalRight" && this.configuration.right_terminal_record != null) {
            return value === this.configuration.right_terminal_record.idterminal;
        }
        return false;
    }
    /**
     * Show all quotes on canvas
     */
    showAllQuotes() {
        this.ballScrewObj.showAllQuotes();
    }
    /**
     * Remove current terminal
     */
    removeTerminal() {
        if (this.panel === "terminalLeft") {
            this.configuration.left_terminal_record = null;
            this.configuration.left_terminal_object = null;
            this.configuration.left_socket = "";
        }
        else {
            this.configuration.right_terminal_record = null;
            this.configuration.right_terminal_object = null;
            this.configuration.right_socket = "";
        }
        this.ballScrewObj.removeTerminals();
        this.renderBallScrew();
        this.sidepanel = false;
    }
    /**
     * Reset modal form
     */
    resetModal() {
        this.configuration.name = "";
        this.configuration.nameState = null;
    }
    /**
     * Handle ok button on modal form
     */
    handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Trigger submit handler
        this.handleSubmit();
    }
    /**
     * Check form validation on modal
     */
    checkFormValidity() {
        const valid = this.$refs.saveForm.checkValidity();
        this.configuration.nameState = valid ? 'valid' : 'invalid';
        return valid;
    }
    /**
     * Handle form submit on modal
     */
    handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
            return;
        }
        // Reset isSaving state
        if (this.idConfiguration <= 0) {
            this.isSaving = true;
        }
        this.submitting = true;
        axios_1.default.post('/api/drawer/save_configuration', {
            selected: this.selected.id,
            terminal_left: this.configuration.left_terminal_record !== null ? this.configuration.left_terminal_record.idterminal : null,
            terminal_right: this.configuration.right_terminal_record !== null ? this.configuration.right_terminal_record.idterminal : null,
            socket_left: this.configuration.left_socket,
            socket_right: this.configuration.right_socket,
            name: this.configuration.name,
            protection: this.configuration.protection.id,
            precision: this.configuration.precision.id,
            lubrication: this.configuration.lubrication.id,
            flange: this.configuration.flange,
            documentations: this.configuration.documentations,
            screwLength: this.configuration.screwLength,
            idconfiguration: this.idConfiguration,
        }).then(res => {
            this.loading = false;
            this.submitting = false;
            if (this.idConfiguration > 0) {
                this.notify("Operazione completata", "I dati sono stati correttamente salvati");
            }
            else {
                document.location.href = '/drawer/list';
            }
        }).catch(err => {
            this.isSaving = false;
            this.loading = false;
            this.submitting = false;
            this.notify("Error", "Si è verificato un errore durante il salvataggio, si prega di riprovare", "error");
        });
        // Hide the modal manually
        this.$nextTick(() => {
            this.$refs['modal-save'].hide();
        });
    }
    /**
     * Function to render a ball screw
     */
    renderBallScrew() {
        // Clear canvas
        this.two.clear();
        // Clear elements to quote
        this.elementsToQuotes.length = 0;
        // Calculate 2/3 of the screen as correct snail width
        let correctWidth = this.elem.offsetWidth / 3.5;
        // Create general Group
        this.configuration.ballScrew = this.ballScrewObj.draw(this.two, this.elem, this.selected, this.configuration, correctWidth);
        this.configuration.ballScrew.translation.y = -this.centerGap;
        this.two.add(this.configuration.ballScrew);
        this.addControls();
        if (this.showQuotes) {
            this.ballScrewObj.showAllQuotes();
        }
        this.two.update();
        this.loading = false;
        this.drawed = true;
        this.startTour();
    }
    /**
     * Check if configuration can be saved
     */
    canBeSaved() {
        return this.configuration.screwLength > 0 && this.configuration.flange !== "" && this.configuration.left_socket != "" && this.configuration.right_socket != "";
    }
    /**
     * Go back to ballscrews list
     */
    goBack() {
        this.endTour();
        this.back = true;
    }
    /**
     * Stop virtual tuour
     */
    endTour() {
        this.$tours['myTour'].stop();
    }
    /**
     * Start a help tour
     */
    startTour(force = false) {
        let canShow = (force) ? true : !this.$store.state.tour;
        if (canShow) {
            this.$tours['myTour'].start();
        }
    }
    /**
     * Add controls buttons
     */
    addControls() {
        if (this.configuration.controls.settings == null) {
            this.configuration.controls.settings = this.getInteractionButton("<i id='mainConf' class='fas fa-cog'>", "Advanced configuration", "pulse orange", () => {
                this.panel = 'settings';
                this.sidepanel = true;
            }, 'main-conf');
            this.elem.appendChild(this.configuration.controls.settings);
        }
        else {
            jquery_1.default(this.configuration.controls.settings).show();
        }
        if (this.configuration.controls.right_terminal == null) {
            this.configuration.controls.right_terminal = this.getInteractionButton("<i id='rightConf' class='fas fa-cog'>", "Configure right shaft end", "pulse", () => {
                this.panel = 'terminalRight';
                this.configuration.terminal = '';
                this.configuration.socket = '';
                this.socketImage = 'f0';
                this.sidepanel = true;
                this.loadTerminal(this.selected.nominal_diameter, this.selected.root_diameter);
            }, 'right_terminal');
            this.elem.appendChild(this.configuration.controls.right_terminal);
        }
        if (this.configuration.right_terminal_record != null && this.configuration.controls.edit_right_terminal == null) {
            this.configuration.controls.edit_right_terminal = this.getInteractionButton("<i id='rightConfEdit' class='fas fa-wrench'>", "Modify right shaft end", "pulse green", () => {
                this.panel = 'terminalRight';
                this.configuration.terminal = this.ballScrewObj.getTerminalImageName(this.configuration.right_terminal_record.code);
                this.configuration.socket = this.configuration.right_socket;
                this.socketImage = this.configuration.socket;
                this.loadTerminal(this.selected.nominal_diameter, this.selected.root_diameter);
                this.sidepanel = true;
            }, 'right_terminal_edit');
            this.elem.appendChild(this.configuration.controls.edit_right_terminal);
        }
        if (this.configuration.controls.left_terminal == null) {
            this.configuration.controls.left_terminal = this.getInteractionButton("<i id='leftConf' class='fas fa-cog'>", "Configure left shaft end", "pulse", () => {
                this.panel = 'terminalLeft';
                this.configuration.terminal = '';
                this.configuration.socket = '';
                this.socketImage = 'f0';
                this.sidepanel = true;
                this.loadTerminal(this.selected.nominal_diameter, this.selected.root_diameter);
            }, 'left_terminal');
            this.elem.appendChild(this.configuration.controls.left_terminal);
        }
        if (this.configuration.left_terminal_record != null && this.configuration.controls.edit_left_terminal == null) {
            this.configuration.controls.edit_left_terminal = this.getInteractionButton("<i id='leftConfEdit' class='fas fa-wrench'>", "Modify left shaft end", "pulse green", () => {
                this.panel = 'terminalLeft';
                this.configuration.terminal = this.ballScrewObj.getTerminalImageName(this.configuration.left_terminal_record.code);
                this.configuration.socket = this.configuration.left_socket;
                this.socketImage = this.configuration.left_socket;
                this.loadTerminal(this.selected.nominal_diameter, this.selected.root_diameter);
                this.sidepanel = true;
            }, 'left_terminal_edit');
            this.elem.appendChild(this.configuration.controls.edit_left_terminal);
        }
        // Fix controls position
        const gap = this.configuration.ballScrew.translation.x;
        this.configuration.controls.settings.style.left = gap + (this.elem.offsetWidth / 2 + 20) + "px";
        this.configuration.controls.settings.style.top = (this.elem.offsetHeight / 2 + 29) - this.centerGap + "px";
        this.configuration.controls.right_terminal.style.left = gap + ((this.elem.offsetWidth / 2) - (this.ballScrewObj.getData().screwWidth / 2) + this.ballScrewObj.getData().screwWidth + 10) + "px";
        this.configuration.controls.right_terminal.style.top = (this.elem.offsetHeight / 2 + 29) - this.centerGap + "px";
        this.configuration.controls.left_terminal.style.left = gap + ((this.elem.offsetWidth / 2) - (this.ballScrewObj.getData().screwWidth / 2) - 60) + "px";
        this.configuration.controls.left_terminal.style.top = (this.elem.offsetHeight / 2 + 29) - this.centerGap + "px";
        if (this.configuration.controls.edit_left_terminal != null && this.ballScrewObj.getData().left_terminal_object != null) {
            this.configuration.controls.edit_left_terminal.style.left = gap + ((this.ballScrewObj.getData().left_terminal_object.translation.x - this.ballScrewObj.getTerminalWidth(this.configuration.left_terminal_record) - 60)) + "px";
            this.configuration.controls.edit_left_terminal.style.top = this.configuration.controls.left_terminal.style.top;
        }
        if (this.configuration.controls.edit_right_terminal != null && this.ballScrewObj.getData().right_terminal_object != null) {
            this.configuration.controls.edit_right_terminal.style.left = gap + ((this.ballScrewObj.getData().right_terminal_object.translation.x + this.ballScrewObj.getTerminalWidth(this.configuration.right_terminal_record) + 10)) + "px";
            this.configuration.controls.edit_right_terminal.style.top = this.configuration.controls.right_terminal.style.top;
        }
        if (this.configuration.left_terminal_record != null) {
            jquery_1.default(this.configuration.controls.left_terminal).hide();
            jquery_1.default(this.configuration.controls.edit_left_terminal).show();
        }
        else {
            jquery_1.default(this.configuration.controls.left_terminal).show();
            jquery_1.default(this.configuration.controls.edit_left_terminal).hide();
        }
        if (this.configuration.right_terminal_record != null) {
            jquery_1.default(this.configuration.controls.right_terminal).hide();
            jquery_1.default(this.configuration.controls.edit_right_terminal).show();
        }
        else {
            jquery_1.default(this.configuration.controls.right_terminal).show();
            jquery_1.default(this.configuration.controls.edit_right_terminal).hide();
        }
    }
    /**
     * Remove all controls buttons
     */
    clearControls() {
        if (this.configuration.controls.right_terminal != null) {
            jquery_1.default(this.configuration.controls.right_terminal).hide();
        }
        if (this.configuration.controls.left_terminal != null) {
            jquery_1.default(this.configuration.controls.left_terminal).hide();
        }
        if (this.configuration.controls.settings != null) {
            jquery_1.default(this.configuration.controls.settings).hide();
        }
        if (this.configuration.controls.edit_left_terminal != null) {
            jquery_1.default(this.configuration.controls.edit_left_terminal).hide();
        }
        if (this.configuration.controls.edit_right_terminal != null) {
            jquery_1.default(this.configuration.controls.edit_right_terminal).hide();
        }
    }
    /**
     * Load an build terminal array based on selected snail
     * @param nomDiameter
     * @param rootDiameter
     */
    loadTerminal(nomDiameter, rootDiameter) {
        this.loading = true;
        axios_1.default.post('/internalapi/get_terminal/' + nomDiameter + '/' + rootDiameter).then(res => {
            let all = res.data;
            this.flange.length = 0;
            for (let key in all) {
                const code = this.ballScrewObj.getTerminalImageName(all[key].code).toLowerCase();
                let item = this.flange.find((el) => {
                    return el.key === code;
                });
                all[key]['actions'] = '';
                if (this.panel === "terminalLeft" && this.configuration.left_terminal_record != null) {
                    if (all[key]['idterminal'] === this.configuration.left_terminal_record.idterminal) {
                        all[key]['_showDetails'] = true;
                    }
                }
                else if (this.panel === "terminalRight" && this.configuration.right_terminal_record != null) {
                    if (all[key]['idterminal'] === this.configuration.right_terminal_record.idterminal) {
                        all[key]['_showDetails'] = true;
                    }
                }
                if (item != null) {
                    item.items.push(all[key]);
                }
                else {
                    this.flange.push({
                        key: code,
                        items: [all[key]]
                    });
                }
            }
            this.loading = false;
        }).catch(err => {
            console.log(err);
        });
    }
    /**
     * Create interaction button
     * @param text
     * @param title
     * @param type
     * @param closure
     * @return HTMLElement
     */
    getInteractionButton(text, title, type = 'pulse', closure, dusk = null) {
        let button = document.createElement("div");
        button.innerHTML = text;
        button.setAttribute('class', type);
        button.setAttribute('data-toggle', 'tooltip');
        button.setAttribute('data-placement', 'top');
        button.setAttribute('title', title);
        if (dusk != null) {
            button.setAttribute('dusk', dusk);
        }
        button.addEventListener("click", closure);
        setTimeout(() => {
            jquery_1.default('[data-toggle="tooltip"]').tooltip();
        }, 0);
        return button;
    }
    /**
     * Set Ball Screw type
     * @param type
     */
    setType(type) {
        this.loading = true;
        this.selected_type = type;
        axios_1.default.post('/internalapi/get_diameter/' + type).then(res => {
            this.diameters = res.data;
            this.loading = false;
        }).catch(err => {
            console.log(err);
            this.loading = false;
        });
        this.stepper.next();
    }
    /**
     * Set Ball Screw diameter
     * @param diameter
     */
    setDiameter(diameter) {
        this.selected_diameter = diameter;
        this.loading = true;
        axios_1.default.post('/internalapi/get_lead/' + this.selected_type + '/' + diameter).then(res => {
            this.leads = res.data;
            this.loading = false;
            if (this.leads.length <= 0) {
                this.selected_star = 0;
            }
            else if (this.selected_lead > 0) {
                let item = this.leads.find((el) => {
                    return el === this.selected_lead;
                });
                if (item == null) {
                    this.selected_lead = 0;
                }
                else {
                    this.setBLead(this.selected_lead);
                }
            }
        }).catch(err => {
            console.log(err);
            this.loading = false;
        });
        this.stepper.next();
    }
    /**
     * Set lead
     * @param lead
     */
    setBLead(lead) {
        this.selected_lead = lead;
        this.loading = true;
        axios_1.default.post('/internalapi/get_stars/' + this.selected_type + '/' + this.selected_diameter + '/' + lead).then(res => {
            this.stars = res.data;
            this.loading = false;
            if (this.stars.length <= 0) {
                this.selected_star = 0;
            }
            if (this.selected_star > 0) {
                let item = this.stars.find((el) => {
                    return el === this.selected_star;
                });
                if (item == null) {
                    this.selected_star = 0;
                }
            }
        }).catch(err => {
            this.loading = false;
        });
    }
    /**
     * Set Ball Screw lead
     * @param lead
     */
    setLead(lead) {
        this.$refs['configuration-modal'].hide();
        this.isBusy = true;
        this.selected_lead = lead;
        this.wizardComplete = true;
    }
    /**
     * Populate all select
     * @param record
     */
    populateAllSelects(record) {
        this.selected_type = record.preload.toLowerCase();
        this.selected_diameter = record.nominal_diameter;
        this.selected_lead = record.lead;
        this.selected_star = record.nr_stars;
        axios_1.default.post('/internalapi/get_all_selects/' +
            record.preload.toLowerCase() + '/' +
            record.nominal_diameter + '/  ' +
            record.lead).then(res => {
            this.wizardComplete = true;
            this.stars = res.data.stars;
            this.leads = res.data.leads;
            this.diameters = res.data.diameters;
            this.getBallScrew(false);
        }).catch(err => {
            this.isBusy = false;
        });
    }
    /**
     * Get all ball screw based on type, diameter and lead
     */
    getBallScrew(showBusy = true) {
        if (this.selected_type != "") {
            this.showNavigation = true;
            if (showBusy) {
                this.isBusy = true;
            }
            axios_1.default.post('/internalapi/get_ballscrew/' + this.selected_type + '/' + this.selected_diameter + '/' + this.selected_lead + '/' + this.selected_star).then(res => {
                this.items = res.data;
                this.isBusy = false;
            }).catch(err => {
                this.isBusy = false;
            });
        }
    }
    /**
     * Set socket and draw image
     * @param item
     * @param socket
     */
    setSocket(item, socket) {
        if (this.panel == "terminalLeft") {
            this.configuration.left_socket = socket;
        }
        else {
            this.configuration.right_socket = socket;
        }
        this.redrawImage(item);
        this.sidepanel = false;
    }
    /**
     * Redraw image with saved terminals
     */
    redrawImage(item) {
        if (this.panel == "terminalLeft") {
            this.configuration.left_terminal_record = item[0];
        }
        else {
            this.configuration.right_terminal_record = item[0];
        }
        this.renderBallScrew();
    }
    /**
     * Get fields based on terminal type
     * @param type
     */
    getFieldFor(type) {
        let base_fields = [
            { key: "code", label: 'Id' },
            { key: "d0", label: 'd0 [mm]' }
        ];
        switch (type.toLowerCase()) {
            case "t1":
                base_fields.push({ key: "d", label: 'd [mm]' });
                base_fields.push({ key: "d5", label: 'd5' });
                base_fields.push({ key: "d4", label: 'd4 [mm]' });
                base_fields.push({ key: "W1", label: 'W1 [mm]' });
                base_fields.push({ key: "W3", label: 'W3 [mm]' });
                base_fields.push({ key: "W", label: 'W [mm]' });
                break;
            case "t2":
                base_fields.push({ key: "d", label: 'd [mm]' });
                base_fields.push({ key: "d5", label: 'd5' });
                base_fields.push({ key: "W3", label: 'W3 [mm]' });
                base_fields.push({ key: "W", label: 'W [mm]' });
                break;
            case "t4":
                base_fields.push({ key: "d", label: 'd [mm]' });
                base_fields.push({ key: "d5", label: 'd5' });
                base_fields.push({ key: "d4", label: 'd4 [mm]' });
                base_fields.push({ key: "W1", label: 'W1 [mm]' });
                base_fields.push({ key: "W3", label: 'W3 [mm]' });
                base_fields.push({ key: "B", label: 'B [mm]' });
                base_fields.push({ key: "L", label: 'L [mm]' });
                base_fields.push({ key: "T", label: 'T [mm]' });
                base_fields.push({ key: "W", label: 'W [mm]' });
                break;
            case "t3":
                base_fields.push({ key: "d", label: 'd [mm]' });
                base_fields.push({ key: "d3", label: 'd3 [mm]' });
                base_fields.push({ key: "W2", label: 'W2 [mm]' });
                base_fields.push({ key: "W4", label: 'W4 [mm]' });
                base_fields.push({ key: "W", label: 'W [mm]' });
                break;
        }
        base_fields.push({ key: "actions", label: 'actions' });
        return base_fields;
    }
    /**
     * Select terminal type based on value
     * @param value
     */
    selectTerminalType(value) {
        if (value.key.toUpperCase() === 'T0') {
            value.items.map((x) => {
                x._showDetails = true;
            });
        }
        this.configuration.terminal = value.key;
    }
    comingsoon() {
        this.$swal({
            html: "Thank you for visiting us and for your interest in our products. This section will be available soon. For further information, please contact us at <a href=\"mailto:industrial@umbragroup.com\">industrial@umbragroup.com</a>",
        });
    }
};
__decorate([
    vue_property_decorator_1.Prop({ default: 0 })
], Drawer.prototype, "idConfiguration", void 0);
__decorate([
    vue_property_decorator_1.Watch('showQuotes')
], Drawer.prototype, "onShowQuotesChanges", null);
__decorate([
    vue_property_decorator_1.Watch('selected_type')
], Drawer.prototype, "onSelectedTypeChanged", null);
__decorate([
    vue_property_decorator_1.Watch('selected_diameter')
], Drawer.prototype, "onSelectedDiameterChanged", null);
__decorate([
    vue_property_decorator_1.Watch('selected_lead')
], Drawer.prototype, "onSelectedLeadChanged", null);
__decorate([
    vue_property_decorator_1.Watch('selected_star')
], Drawer.prototype, "onSelectedStarChanged", null);
Drawer = __decorate([
    vue_property_decorator_1.Component({
        components: {
            'vue-slideout-panel': vue_slideout_panel_vue_1.default
        }
    })
], Drawer);
exports.default = Drawer;
